import { Box, Tooltip, Typography } from '@mui/material';
import React from 'react';
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import Image1 from '../../../assets/images/landing/Frame1.png';
import Image2 from '../../../assets/images/landing/Frame2.png';
import Image3 from '../../../assets/images/landing/Frame3.png';
import Image4 from '../../../assets/images/landing/Frame4.png';

const TopLine = styled('div')`
	position: absolute;
	top: -2px;
	left: 16.5px;
	width: 1px;
	height: 25px;
	background-color: rgb(138, 140, 146);
	transform: rotate(45deg);
	transform-origin: left top;
	z-index: 13;
`;

const BottomLine = styled('div')`
	position: absolute;
	width: 1px;
	height: 25px;
	background-color: rgb(138, 140, 146);
	transform: rotate(45deg);
	transform-origin: left top;
	z-index: 13;
	bottom: -9px;
	right: -0.5px;
`;

const GridItem = styled('div')`
	display: flex;
	flex-direction: row;
	align-items: center;
	background-color: #fff;
	backdrop-filter: blur(20px);
	border-radius: 5px;

	position: relative;
	height: 100%;
	clip-path: polygon(
		15px 0,
		100% 0,
		100% calc(100% - 15px),
		calc(100% - 15px) 100%,
		0 100%,
		0 15px
	);

	&:before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		border: 1px solid #8a8c92;
		clip-path: inherit;
		pointer-events: none;
	}
	padding: 20px;
`;

const Grid = styled('div')`
	display: grid;
	width: 100%;
	grid-template-columns: repeat(4, 1fr);
	padding: 40px 0 0 0;
	column-gap: 20px;
	max-width: 1250px;

	@media (max-width: 1100px) {
		grid-template-columns: repeat(2, 1fr);
		column-gap: 10px;
		row-gap: 30px;
	}
`;

const Row = styled('div')`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
`;

const StyledBox = styled('div')(() => ({
	display: 'flex',
	padding: '4px 8px',
	justifyContent: 'center',
	alignItems: 'baseline',
	backgroundColor: '#9C69F6',
	borderRadius: 4,
	width: 'min-content',
	height: 'min-content',
	marginLeft: 10,
}));

const Column = styled('div')`
	display: flex;
	flex-direction: column;
	align-items: start;
	margin-left: 12px;
`;

export const TVLHeader: React.FC<{
	contractBal: string;
}> = ({ contractBal }) => {
	const selectedVault = useSelector((state: RootState) => state.vault);

	return (
		<Grid>
			<GridItem>
				<TopLine />
				<BottomLine />
				<img width={48} height={48} src={Image1} />
				<Column>
					<Typography
						variant="caption"
						fontWeight={500}
						display={'inline'}
						color={'#777'}
					>
						TVL
					</Typography>
					<Box height={4} />
					<Typography
						variant="subtitle1"
						fontWeight={500}
						display={'inline'}
					>
						10000 {selectedVault.token[0].name}
					</Typography>
				</Column>
			</GridItem>
			<Tooltip
				title="Past month return is the annualized return of the vault based on the past month to reduce noise. Return is calculated based on the overall profit from strategies executed by Dudu. Past returns are not indicative of future performance."
				arrow
				placement="top" // Always open on top
				componentsProps={{
					tooltip: {
						sx: {
							fontFamily: 'Roboto Mono',
							backgroundColor: '#e4e8ff',
							border: '1px solid #345CF8',
							color: '#000',
						},
					},
					arrow: {
						sx: {
							color: '#345CF8', // Match arrow color to tooltip background
						},
					},
				}}
			>
				<GridItem>
					<TopLine />
					<BottomLine />
					<img width={48} height={48} src={Image2} />
					<Column>
						<Typography
							variant="caption"
							fontWeight={500}
							display={'inline'}
							color={'#777'}
						>
							Past Month Return
						</Typography>
						<Box height={4} />
						<Row>
							<Typography
								variant="subtitle1"
								fontWeight={500}
								display={'inline'}
							>
								8.26%
							</Typography>

							<StyledBox>
								<Typography
									variant="caption"
									fontWeight={500}
									display={'inline'}
									color={'#fff'}
								>
									APY
								</Typography>
							</StyledBox>
						</Row>
					</Column>
				</GridItem>
			</Tooltip>
			<GridItem>
				<TopLine />
				<BottomLine />
				<img width={48} height={48} src={Image3} />
				<Column>
					<Typography
						variant="caption"
						fontWeight={500}
						display={'inline'}
						color={'#777'}
					>
						Your Deposits
					</Typography>
					<Box height={4} />
					<Typography
						variant="subtitle1"
						fontWeight={500}
						display={'inline'}
					>
						{contractBal} {selectedVault.token[0].name}
					</Typography>
				</Column>
			</GridItem>
			<GridItem>
				<TopLine />
				<BottomLine />
				<img width={48} height={48} src={Image4} />
				<Column>
					<Typography
						variant="caption"
						fontWeight={500}
						display={'inline'}
						color={'#777'}
					>
						All-time Earned
					</Typography>
					<Box height={4} />
					<Typography
						variant="subtitle1"
						fontWeight={500}
						display={'inline'}
					>
						-
					</Typography>
				</Column>
			</GridItem>
		</Grid>
	);
};
